import type { ServerMessages } from '../de/server.js';

export const server: ServerMessages = {
  unauthenticated: 'Please sign in',
  forbidden: 'Not allowed',
  notFound: 'Not found',
  invalidInput: 'Invalid input',
  payloadTooLarge: 'Too much data',
  rateLimited: 'Too many requests, please try again later',
  badRequest: 'Invalid request',
  internal: 'Internal server error',
  csrf: 'Request rejected: protection header missing',
  userNotFound: 'User not found',
  priceCatalogNotFound: 'Price catalog not found',
  priceCatalogDefault: 'The default catalog stays – make another catalog the default first',
  emailTaken: 'This email address is already registered',
  ownPasswordReset: 'Please set your own password via “Change password”',
  rejectOnlyPending: 'Only registrations not yet approved can be rejected',
  ownAccount: 'Your own account cannot be changed here',
  lastAdmin: 'At least one active administrator must remain',
  registrationDisabled: 'Registration is disabled',
  invalidAccessCode: 'The access code is wrong',
  invalidCredentials: 'Wrong email or password',
  accountPending: 'Your account is still waiting for approval by the administrator',
  wrongPassword: 'The current password is wrong',
  noFile: 'No file received',
  glbOnly: 'Please upload a .glb file',
  modelNotFound: 'Model not found',
  modelFileMissing: 'Model file missing in storage',
  modelUnavailable: 'The model does not exist or is not shared',
  unknownModels: 'The project refers to unknown models',
  projectNotFound: 'Project not found',
  projectCorrupt: 'The saved project is damaged',
  projectIdMismatch: 'Project ID does not match',
  documentRejected: '{detail}',
  projectChanged: 'The project has been changed in the meantime',
  versionNotFound: 'Version not found',
  versionCorrupt: 'The saved version is damaged',
  saveBeforeReport: 'Please save first – the report is created from the saved state',
  invalidReportImage: 'View “{title}” is not a valid image',
  invalidThumbnail: 'The preview image is invalid',
  glbTooSmall: 'The file is too small for a GLB model',
  glbNoMagic: 'Not a valid GLB file (identifier missing)',
  glbVersion: 'Only glTF 2.0 is supported',
  glbTruncated: 'The GLB file is incomplete or damaged',
  glbNoJson: 'The GLB file has no valid JSON chunk',
  glbBadJson: 'The GLB file contains invalid JSON',
  glbExternal: 'External file references are not supported – please export a self-contained GLB',
  glbUnreadable: 'The model could not be read: {detail}',
  glbNoScene: 'The model contains no scene',
  glbNoGeometry: 'The model contains no visible geometry',
  imageFormat: 'Please upload a JPG or PNG image or a PDF drawing',
  imageSize: 'The image size is invalid',
  imageTooLarge: 'The image is too large (at most {max} pixels per side)',
  videoFormat: 'Please upload an MP4 or WebM video',
  videoTooLarge: 'The video is too large (at most {max})',
  videoTooLong: 'The video is too long (at most 15 minutes)',
  videoQuota:
    'The storage for videos is full ({used} of {quota} used). Please delete older videos.',
  videoNotFound: 'Video not found',
  rangeInvalid: 'Invalid range requested',
  readOnlyProject: 'This project is shared with you for viewing only',
  ownerOnly: 'Only the owner of the project may do this',
  memberUnknown: 'No user is registered with this email address',
  memberIsOwner: 'The owner has full access anyway',
  memberNotFound: 'This person has no access to the project',
  chatMessageNotFound: 'Message not found',
  chatFileNotFound: 'File not found',
  chatNotYours: 'Only your own messages can be deleted',
  interpreterUnavailable: 'No interpreter is set up for these languages',
  interpreterFailed: 'The interpreter service cannot be reached right now',
  dictationUnavailable: 'Dictation is not set up on this server',
  dictationFailed: 'Speech recognition cannot be reached right now, please try again',
};
